import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Admission Date:</span>
                            <input type='date' id="txt_1" name="txt_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Discharge Date:</span>
                            <input type='date' id="txt_2" name="txt_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Insurance Type/Number:</span>
                            <input type='text' id="txt_3" name="txt_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Reason for Transfer/Discharge:</span>
                    <textarea id="txt_4" name="txt_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Living Situation at the Time of Discharge:</span>
                    <textarea id="txt_5" name="txt_5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Presenting Condition:</span>
                    <span className='small'>(According to the "Presenting Condition" section of
                        the Biopsychosocial Assessment that was completed upon admission)</span>
                    <textarea id="txt_6" name="txt_6" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Discharge (Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_7" name="cb_7" className='add-only' value="1" /> Successfully completed program
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_8" name="cb_8" className='add-only' value="1" /> Referred/Transferred to more intense
                            level of care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_9" name="cb_9" className='add-only' value="1" /> Referred/Transferred to a less intense
                            level of care
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_10" name="cb_10" className='add-only' value="1" /> Left voluntarily by choice
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_11" name="cb_11" className='add-only' value="1" /> Lack of progress, program initiated
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_12" name="cb_12" className='add-only' value="1" /> Lack of progress, participant
                            initiated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_13" name="cb_13" className='add-only' value="1" /> Program rule violation
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_14" name="cb_14" className='add-only' value="1" /> Medical Problem, unable to
                            participate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_15" name="cb_15" className='add-only' value="1" /> Legal Problem/Situation, unable to
                            participate
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_16" name="cb_16" className='add-only' value="1" /> Change in geographic/living location
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_17" name="cb_17" className='add-only' value="1" /> Insurance Change
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_18" name="cb_18" className='add-only' value="1" /> Other:
                            &nbsp;
                            <input id="txt_19" name="txt_19" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Status of Treatment Goals at Discharge</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_19" name="cb_19" className='add-only' value="1" /> Accomplished
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_20" name="cb_20" className='add-only' value="1" /> Significant Progress
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_21" name="cb_21" className='add-only' value="1" /> Moderate Progress
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_22" name="cb_22" className='add-only' value="1" /> Minor Progress
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cb_23" name="cb_23" className='add-only' value="1" /> No Progress
                        </td>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Summary of Treatment Progress:</span>
                    <textarea id="txt_24" name="txt_24" className='add-only'></textarea>
                </p>
                <h3>Hopes / Choices / Preferences / Desired Outcomes</h3>
                <p>
                    <span className='eleHeader'>What Hopes does the Individual have regarding their treatment? </span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources,
                        education)</span>
                    <textarea id="txt_25" name="txt_25" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Choices does the Individual have regarding meeting his/her needs? </span>
                    <span className='small'>(Name specific resources, community opportunities, etc.) </span>
                    <textarea id="txt_26" name="txt_26" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Preferences does the Individual have regarding his/her treatment? </span>
                    <span className='small'>(This should male/female community staff, meeting location and/or time, staff with
                        specific specialty, etc.) </span>
                    <textarea id="txt_27" name="txt_27" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's Desired Outcomes for treatment? </span>
                    <span className='small'>(What does the Individual expect to achieve throughout his/her treatment?) </span>
                    <textarea id="txt_28" name="txt_28" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>DSM-5/ICD-10 Diagnostic Impression:</span>
                    <textarea id="txt_29" name="txt_29" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendation for Ongoning Service Type:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_30" name="cb_30" className='add-only' value="1" /> CSI
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_31" name="cb_31" className='add-only' value="1" /> Individual/FamilyTherapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_32" name="cb_32" className='add-only' value="1" /> Mentor Program
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_33" name="cb_33" className='add-only' value="1" /> Psychiatric Services and Med
                            Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_34" name="cb_34" className='add-only' value="1" /> Other:
                            &nbsp;
                            <input id="txt_34_1" name="txt_34_1" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>Individual Reffered To</h3>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Person/Agency</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Location/Address</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Phone Number</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Contact Person</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>First (or next) Appointment (time and date)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input id="txt_35" name="txt_35" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_36" name="txt_36" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_37" name="txt_37" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_38" name="txt_38" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_39" name="txt_39" className='add-only' type='text' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input id="txt_40" name="txt_40" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_41" name="txt_41" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_42" name="txt_42" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_43" name="txt_43" type='text' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input id="txt_44" name="txt_44" className='add-only' type='text' />
                        </td>
                    </tr>
                </table>
                <h3>Discharge Summary Completed by</h3>
                <table>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'> Print Name / Credentials and Date: </td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'> Signature / Credentials and Date: </td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'> Individual / Parent Signature: </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375 signature'>&nbsp;</td>
                        <td className='w-375 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Reviewed By Licensed Professional:</td>
                        <td className='small'>Print/Date: </td>
                    </tr>
                    <tr>
                        <td className='w-375 signature'>&nbsp;</td>
                        <td className='w-375 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Reviewed By Licensed Professional:</td>
                        <td className='small'>Sign/Date: </td>
                    </tr>
                </table>



                {/* HTML code end here */}


            </div>
        </form >
    )
}